import { render } from "./ProductCount.vue?vue&type=template&id=0e884d34"
import script from "./ProductCount.vue?vue&type=script&lang=js"
export * from "./ProductCount.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__